<template>
  <div class="card card-stats">
    <div class="card-body">
      <div class="row">
        <div class="col-6 col-md-4">
          <slot name="content">
            <div class="numbers-serviam">
              <p class="card-category">{{smallTitle}}</p>
              <p class="card-title">{{title}}</p>
            </div>
          </slot>
        </div>
        <div class="col-6 col-md-8">
          <slot name="content-right"></slot>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'stats-card-serviam',
    props:{
      type: {
        type: String,
        description: 'Card text type (primary|info|danger|default|warning|success)'
      },
      title: {
        type: String,
        description: 'Card title'
      },
      smallTitle: {
        type: String,
        description: 'Card small title'
      },
      icon: {
        type: String,
        description: 'Card icon'
      }
    }
  }

</script>
<style scoped>
    .card {
        max-height: 130px;
        min-height: 130px;
    }
    .card-content{
        min-height: 130px;
        max-height: 130px;
    }
    .card-category {
        font-weight: bold;
        text-transform: uppercase;
        white-space: nowrap;
    }
    .card-title {
        font-size: 3em;
        font-style: italic;
        white-space: nowrap;

    }
    .img-slot {
        max-height: 112px;
    }

    .concentric-circles {
        width: 100%;
        height: auto;
        text-align: center;
        margin: 0 auto;
        margin-top: 50px;
    }

    .circle {
        display: inline-block;
        height: 40px;
        width: 40px;
        font-size: 18px;
        line-height: 18px;
        border-radius: 50%;
        color: white;

    }
    .concentric-circles div span{
        display: flex;
        justify-content: center;
        align-items: center
    }
    .concentric-circles div span:nth-child(1){
        position: relative;
        z-index: 10;
        background-color:#BDBDBD;
    }
    .concentric-circles div span:nth-child(2){
        position: relative;
        z-index: 9;
        background-color: #e5e2e2;
        margin-left: -10px
    }
    .concentric-circles div span:nth-child(3){
        position: relative;
        z-index: 8;
        background-color: #afbed3;
        margin-left: -10px
    }
    .concentric-circles div span:nth-child(4){
        position: relative;
        z-index: 7;
        background-color: #aed5d0;
        margin-left: -10px
    }
    .concentric-circles div span:nth-child(5){
        position: relative;
        z-index: 6;
        background-color: #f5a468;
        margin-left: -10px
    }
    .concentric-circles div span:nth-child(6){
        position: relative;
        z-index: 5;
        background-color: #aaaaaa;
        margin-left: -10px
    }
    .concentric-circles div{
        margin-top: 0.5em;
        font-size: 2em;
        font-family: BrandonGrotesque, Brandon Grotesque;
        font-weight: 350;
        display: flex;
        justify-content: center;
    }
</style>
